import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { ConversionQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The one unit-conversion dial (ADR 0032 §2).
 *
 * There is deliberately no size setting beside it: what makes a conversion
 * hard is the unit pair - 36 inches to a yard is harder than 2 cups to a pint
 * whatever the numbers are - and the system picker already chooses that.
 */
export function ConversionSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: ConversionQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, ConversionQuestion: value });
    }

    return (
        <div className="conversionSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.ConversionQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(ConversionQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.unitSystemAria')}
                />
            </div>
        </div>
    );
}

export default ConversionSettings;
